module.exports = __webpack_public_path__ + "img/icon-envelope.6a9a2386.svg";